<template>
  <div>
    <ods-button size="medium" @click="dialogTableVisible = true">Nuevo Terminal</ods-button>
    <ods-form :model="datosTerminales" :rules="ticketRules" ref="datosTerminales">
      <div class="default-form">
        <ods-dialog
            :visible.sync="dialogTableVisible"
            :before-close="handleCloseTerm"
            width="800"
            :append-to-body="true">
                <div class="grid-content bg-purple" style="text-align: left;">
                    <span style="font-weight: $font-weight-regular; font-size: 15px;">Alta de Terminal</span>
                </div>
            <ods-row :gutter="10" style="margin-top: 3%">
              <ods-col :span="8">
                <ods-form-item label="Terminal" prop="codterm">
                    <ods-select v-model="datosTerminales.codterm" size="hecto" id="idcodterm">
                      <ods-option
                        v-for="item in newlistadoTPV"
                        :key="item.codterm"
                        :value="item.codterm + ' - '+ item.dattpv">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="Descripción" prop="texto">
                  <ods-input
                    v-model="datosTerminales.texto"
                    size="hecto"></ods-input>
                  </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="Usuario" prop="usuario">
                    <ods-select v-model="datosTerminales.usuario" size="hecto">
                      <ods-option
                        v-for="item in this.listadoUsuarios"
                        :key="item.usuario"
                        :value="item.usuario">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
            </ods-row>
              <span slot="footer" class="dialog-footer">
                <ods-button style="position: absolute; right: 7%; margin-top: -2%;" size="medium" type="secondary;" @click="onSubmit(datosTerminales, 'datosTerminales')">guardar
                </ods-button>
              </span>
        </ods-dialog>
      </div>
    </ods-form>
      <dialog-generic-error
        :message="errorMessage"
        :dialogError="dialogError"
        :before-close-fn="handleCloseSession"
        @dialogClosed="closeDialogError($event)">
      </dialog-generic-error>
      <dialog-generic-success
        :dialogSuccess="dialogSuccess"
        @dialogClosed="closeDialogSuccess($event)">
      </dialog-generic-success>
      <dialog-generic-warning
        :message="warningMessage"
        :dialogWarning="dialogWarning"
        @dialogClosed="closeDialogWarning($event)">
      </dialog-generic-warning>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import DialogConfirmSuccess from '@/components/dialogs/DialogConfirmSuccess'
import DialogGenericWarning from '@/components/dialogs/DialogGenericWarning'
export default {
  props: ['codcomercio', 'desdescomercio', 'listadoTPV'],
  data () {
    var validateTerminal = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Por favor, introduce un terminal'))
      } else {
        callback()
      }
    }
    var validateDescripcion = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Por favor, introduce la descripción'))
      } else {
        callback()
      }
    }
    return {
      dialogTableVisible: false,
      datosTerminales: {
        codterm: '',
        texto: '',
        usuario: '',
        codcom: ''
      },
      dialogError: false,
      dialogSuccess: false,
      dialogWarning: false,
      hasErrors: false,
      newlistadoTPV: this.listadoTPV,
      errorMessage: '',
      warningMessage: '',
      ticketRules: {
        codterm: [
          { required: false, validator: validateTerminal, trigger: 'blur' }
        ],
        texto: [
          { required: false, validator: validateDescripcion, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    listadoTPV (newval, oldval) {
      this.newlistadoTPV = newval
    }
  },
  methods: {
    onSubmit (datosTerminales, nombreTerminal) {
      this.datosTerminales.codterm = this.datosTerminales.codterm.substring(0, 4)
      this.datosTerminales.codcom = this.codcomercio
      this.datosTerminales.nomcomred = this.desdescomercio
      this.$refs[nombreTerminal].validate((valid) => {
        if (valid) {
          this.$store.dispatch('insertTpv', datosTerminales).then(r => {
            this.refreshListTerminal()
            this.handleCloseTerm()
            if (r.error === true) {
              this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
            } else if (r.warning === true) {
              this.displayErrorWarning(r.data.runServiceResponse.return.descRetorno)
            } else {
              this.displayConfirmSuccess()
            }
          }).catch(e => {
            console.error('Error in list Users - App', e)
          })
        }
      })
    },
    handleCloseTerm () {
      this.$refs.datosTerminales.resetFields()
      this.dialogTableVisible = false
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    closeDialogSuccess (e) {
      this.$emit('success', e)
      this.dialogSuccess = e
    },
    closeDialogWarning (e) {
      this.dialogWarning = e
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    displayConfirmSuccess () {
      this.dialogSuccess = true
    },
    displayErrorWarning (msg) {
      this.warningMessage = `${msg}`
      this.dialogWarning = true
    },
    refreshListTerminal () {
      this.$store.dispatch('listTpv', { codcom: this.codcomercio }).then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } if (r.vacio === true) {
          this.$emit('mostrarVentanaTerminal', false)
        } else {
          this.$emit('mostrarVentanaTerminal', true)
        }
      }).catch(e => {
        console.error('Error in list TPVS - App', e)
      })
    }
  },
  ...mapGetters([
    'getlistUsersData',
    'getVisorTPVS'
  ]),
  computed: {
    listadoUsuarios () {
      let datosUsers = []
      if (this.$store.getters.getlistUsersData !== undefined) {
        if (this.$store.getters.getlistUsersData !== '') {
          datosUsers = this.$store.getters.getlistUsersData
          datosUsers.forEach(element => {
            element.nomcompleto = (element.nombre) + ' ' + (element.apelli1) + ' ' + (element.apelli2)
          })
        }
      }
      return datosUsers
    },
    listCodterm () {
      let datosCodterm = []
      if (this.$store.getters.getVisorTPVS !== undefined) {
        if (this.$store.getters.getVisorTPVS !== '') {
          datosCodterm = this.$store.getters.getVisorTPVS
        }
      }
      return datosCodterm
    }
  },
  components: {
    DialogGenericError,
    'dialog-generic-success': DialogConfirmSuccess,
    'dialog-generic-warning': DialogGenericWarning
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ods-form-item__label {
  display: contents;
}
</style>
